export default __webpack_public_path__ + "static/media/DeleteAcBtn.d600a532.png";